import { render, staticRenderFns } from "./PointGenerate.vue?vue&type=template&id=3dd15de8&"
import script from "./PointGenerate.vue?vue&type=script&lang=ts&"
export * from "./PointGenerate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports